import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import CurrencyView from '../modules/CurrencyView';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Helper
import { getDateUsingTimeZone } from '../../../helpers/dateRange';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class CancelledByHost extends Component {
	static propTypes = {
		content: PropTypes.shape({
			guestName: PropTypes.string.isRequired,
			checkIn: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired,
			refundToGuest: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired
		}).isRequired
	};

	static defaultProps = {
		content: {
			refundToGuest: 0
		}
	};

	render() {
		const { content: { guestName, checkIn, listTitle, refundToGuest, currency, logo, country, siteName, checkOut } } = this.props;
		let checkInDate, momentStartDate, today, checkOutDate, interval,isPastDay;
		checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : ''
		checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : ''

		momentStartDate = moment(checkIn).startOf('day');
		today = getDateUsingTimeZone(country, false), interval = momentStartDate.diff(today, 'days'), isPastDay = false;
		if (interval < 0) {
			isPastDay = true;
		}
		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Bonjour {guestName},
					</div>
					<EmptySpace height={20} />
					<div>
						<div style={marginBottom}>Malheureusement, votre réservation pour {listTitle} du {checkInDate} au {checkOutDate} a été annulée par l'hôte.</div>
						{
							refundToGuest > 0 && <span>
								Conformément à la politique d'annulation, vous serez remboursé de <CurrencyView amount={refundToGuest} currency={currency} />, et nous vous en informerons.
							</span>
						}
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default CancelledByHost;
